import React from 'react';
import styled from 'styled-components';

const Login = () => {
  return <Container>
        <ContentBox>
        <LogoOne src="/images/cta-logo-one.svg" />
        <SignUp>GET ALL THERE</SignUp>
        <Description>
            Get access to all movies videos at very less price go subscribe and watch your favourite movies
        </Description>
        <LogoTwo src="/images/cta-logo-two.png" />
        </ContentBox>
  </Container>;
};

export default Login;

const Container = styled.div`
    position: relative;
    height: calc(100vh - 70px);
    display: flex;
    align-items: center;
    justify-content: center;

    &:before {
        position: absolute;
        top:0;
        bottom: 0;
        content: '';
        left:0;
        right:0;
        background-image: url("/images/login-background.jpg");
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        z-index: -1;
        opacity: 0.7;
    }`

    const ContentBox = styled.div`
    max-width: 650px;
    padding: 80px 40px;
    width: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;

    `
    const LogoOne = styled.img``

    const SignUp = styled.a`
    width: 100%;
    background-color: #0063e5;
    font-weight: bold;
    padding: 17px 0px;
    color: #f9f9f9;
    border-radius: 4px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    transition: all 250ms;
    letter-spacing: 1.5px;
    margin-top: 8px;
    margin-bottom: 12px;

    &:hover {
        background: #0483ee;
    }
    `

    const Description = styled.p`
    font-size: 11px;
    letter-spacing: 1.5px;
    text-align: center;
    line-height: 1.5;
    `

    const LogoTwo = styled.img`
    width: 90%;

    `